/* global G */
import { pipe } from 'lib/util'
import { usesGetterSetter, usesScopedNamespace } from '@gaia/trait/uses'
import { withGetterSetter } from '@gaia/trait/with'
import { modelComposition } from '@gaia/trait/composition'
import api from './api'
import validator from './validator'

const descriptor = 'model::account'

const Model = pipe(
  modelComposition(descriptor),
  withGetterSetter(G.VALIDATOR),
  usesGetterSetter(G.VALIDATOR, validator),
  usesScopedNamespace(G.API, api),
)

export default Model
